/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SiteUptimeSummary
 */
export interface SiteUptimeSummary {
    /**
     * Site device group tag
     * @type {string}
     * @memberof SiteUptimeSummary
     */
    deviceGroupTag?: string;
    /**
     * Site name
     * @type {string}
     * @memberof SiteUptimeSummary
     */
    siteName?: string;
    /**
     * Number of chargers at this site
     * @type {number}
     * @memberof SiteUptimeSummary
     */
    chargerCount?: number;
    /**
     * Average device uptime percentage (0-1). Offline periods are not considered.
     * @type {number}
     * @memberof SiteUptimeSummary
     */
    avgDeviceUptimeOfflineIncluded?: number;
    /**
     * Average device uptime percentage (0-1). Offline periods are removed from calculation.
     * @type {number}
     * @memberof SiteUptimeSummary
     */
    avgDeviceUptimeOfflineExcluded?: number;
    /**
     * Preferred device uptime based on organisation preference.
     * @type {number}
     * @memberof SiteUptimeSummary
     */
    preferredDeviceUptime?: number;
    /**
     * Whether offline is included in device uptime calculation.
     * @type {boolean}
     * @memberof SiteUptimeSummary
     */
    isOfflineIncludedInDeviceUptime?: boolean;
    /**
     * Parent organisation device group tag
     * @type {string}
     * @memberof SiteUptimeSummary
     */
    orgGroupTag?: string;
    /**
     * Parent organisation name
     * @type {string}
     * @memberof SiteUptimeSummary
     */
    orgName?: string;
    /**
     * Calculation period start
     * @type {Date}
     * @memberof SiteUptimeSummary
     */
    periodStart?: Date;
    /**
     * Calculation period end
     * @type {Date}
     * @memberof SiteUptimeSummary
     */
    periodEnd?: Date;
}

/**
 * Check if a given object implements the SiteUptimeSummary interface.
 */
export function instanceOfSiteUptimeSummary(
    value: object,
): value is SiteUptimeSummary {
    return true;
}

export function SiteUptimeSummaryFromJSON(json: any): SiteUptimeSummary {
    return SiteUptimeSummaryFromJSONTyped(json, false);
}

export function SiteUptimeSummaryFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): SiteUptimeSummary {
    if (json == null) {
        return json;
    }
    return {
        deviceGroupTag:
            json["deviceGroupTag"] == null ? undefined : json["deviceGroupTag"],
        siteName: json["siteName"] == null ? undefined : json["siteName"],
        chargerCount:
            json["chargerCount"] == null ? undefined : json["chargerCount"],
        avgDeviceUptimeOfflineIncluded:
            json["avgDeviceUptimeOfflineIncluded"] == null
                ? undefined
                : json["avgDeviceUptimeOfflineIncluded"],
        avgDeviceUptimeOfflineExcluded:
            json["avgDeviceUptimeOfflineExcluded"] == null
                ? undefined
                : json["avgDeviceUptimeOfflineExcluded"],
        preferredDeviceUptime:
            json["preferredDeviceUptime"] == null
                ? undefined
                : json["preferredDeviceUptime"],
        isOfflineIncludedInDeviceUptime:
            json["isOfflineIncludedInDeviceUptime"] == null
                ? undefined
                : json["isOfflineIncludedInDeviceUptime"],
        orgGroupTag:
            json["orgGroupTag"] == null ? undefined : json["orgGroupTag"],
        orgName: json["orgName"] == null ? undefined : json["orgName"],
        periodStart:
            json["periodStart"] == null
                ? undefined
                : new Date(json["periodStart"]),
        periodEnd:
            json["periodEnd"] == null ? undefined : new Date(json["periodEnd"]),
    };
}

export function SiteUptimeSummaryToJSON(value?: SiteUptimeSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        deviceGroupTag: value["deviceGroupTag"],
        siteName: value["siteName"],
        chargerCount: value["chargerCount"],
        avgDeviceUptimeOfflineIncluded: value["avgDeviceUptimeOfflineIncluded"],
        avgDeviceUptimeOfflineExcluded: value["avgDeviceUptimeOfflineExcluded"],
        preferredDeviceUptime: value["preferredDeviceUptime"],
        isOfflineIncludedInDeviceUptime:
            value["isOfflineIncludedInDeviceUptime"],
        orgGroupTag: value["orgGroupTag"],
        orgName: value["orgName"],
        periodStart:
            value["periodStart"] == null
                ? undefined
                : value["periodStart"].toISOString(),
        periodEnd:
            value["periodEnd"] == null
                ? undefined
                : value["periodEnd"].toISOString(),
    };
}
